import React from 'react';
import './Item.css';
import { Link } from 'react-router-dom';

const Item = (props) => {
    return (
        <div className="item">
            <Link to={`/product/${props.id}`}>  <img onClick={window.scrollTo(0, 0)} src={props.image} alt={props.name} className="item-image" /></Link>

            <p className="item-name">{props.name}</p>

            <div className="item-prices">
                <span className="item-price-new"> Price: ${props.new_price}- <span className='item-price-old'>${props.old_price}</span> </span>
                {/* <span className="item-price-old">${old_price}</span> */}
            </div>
        </div>
    );
};

export default Item;
